import { CloseIcon } from '@components'
import settings from '@config/settings'
import { COOKIE, COOKIE_NAME } from '@constants'
import CookieImage from '@icons/cookie.svg'
import { GlobalContext, tr } from 'mmfintech-commons'
import { Button, SwitchInput } from 'mmfintech-portal-commons'
import { useContext, useState } from 'react'
import './ManageCookies.scss'

interface Props {
  setCookie: (name: string, value: string, options: { days: number; maxAge: number; domain: string }) => void
}

function ManageCookies({ setCookie }: Props) {
  const { modalHide } = useContext(GlobalContext)

  const [optionalCookies, setOptionalCookies] = useState(true)

  return (
    <div className='manage-cookies' data-test='manage-cookies-modal'>
      <CloseIcon onClick={() => modalHide()} />

      <div className='manage-cookies__title'>
        <div>
          <img src={CookieImage} alt='Cookie' />
        </div>
        <div>
          <h1>{tr('FRONTEND.COOKIE_CONSENT.COOKIE_POLICY', 'The Guardian Bank cookies policy')}</h1>
        </div>
      </div>

      <div className='manage-cookies__necessary'>
        <div>
          <h2 className='title'>{tr('FRONTEND.COOKIE_CONSENT.NECESSARY_COOKIES_TITLE', 'Necessary cookies')}</h2>
          <p>
            {tr(
              'FRONTEND.COOKIE_CONSENT.NECESSARY_COOKIES',
              'We need to use these cookies to make our website work. These are all necessary for us to function and cannot be switched off in our systems. They are for setting responses to actions made by you, such as setting your privacy preferences, logging in or filling forms.'
            )}
          </p>
        </div>
        <div>
          <SwitchInput disabled outline checked />
        </div>
      </div>

      <div className='manage-cookies__optional'>
        <div>
          <h2>{tr('FRONTEND.COOKIE_CONSENT.COOKIE_POLICY', 'The Guardian Bank cookies policy')}</h2>
          <p>
            {tr(
              'FRONTEND.COOKIE_CONSENT.COUNT_VISITS',
              'These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. All information that our cookies collect is aggregated and anonymous.'
            )}
          </p>
          <p>
            {tr(
              'FRONTEND.COOKIE_CONSENT.SEE_PAGES_AND_LINKS',
              "These also allow us to see the pages and links you have visited so we can prevent relevant ads. We don't store directly personal information but identify your browser and internet device. If you do not allow these cookies, you will experience less targeted advertising."
            )}
          </p>
        </div>

        <div>
          <SwitchInput outline checked={optionalCookies} onChange={e => setOptionalCookies(e.target.checked)} />
        </div>
      </div>

      <div className='manage-cookies__save'>
        <Button
          type='button'
          className='btn-consent'
          text={tr('FRONTEND.COOKIE_CONSENT.SAVE_BUTTON', 'Save')}
          onClick={() => {
            setCookie(
              COOKIE_NAME.CONSENT,
              JSON.stringify({
                necessaryCookies: true,
                optionalCookies
              }),
              {
                days: COOKIE.EXPIRATION_DAYS,
                maxAge: COOKIE.MAX_AGE_SECONDS,
                domain: settings.cookieDomain
              }
            )

            modalHide()
          }}
          data-test='button-save'
        />
      </div>
    </div>
  )
}

export default ManageCookies
